<template>
  <section>
    <!--工具条-->
    <!-- <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar> -->
    <!-- <el-button type="primary" @click="division_add()">新增</el-button> -->
    <el-form :inline="true" v-if="buttonList != null && buttonList.length > 0" :model="filters" @submit.native.prevent
      @row-click="selectCurrentRow">
      <el-form-item label="课程名称">
        <el-input v-model="filters.Subject" placeholder="请输入课程名称"></el-input>
      </el-form-item>
      <el-form-item label="授课老师">
        <el-input v-model="filters.Teacher" placeholder="请输入授课老师"></el-input>
      </el-form-item>
      <el-form-item label="课程类型">
        <el-select v-model="filters.Type" clearable placeholder="请选择课程类型">
          <el-option label="全部" :value="-1"></el-option>
          <el-option label="线上培训" value="0"></el-option>
          <el-option label="线下培训" value="1"></el-option>
        </el-select>
      </el-form-item>

      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <el-button :type="item.Func &&
          (item.Func.toLowerCase().indexOf('handledel') != -1 ||
            item.Func.toLowerCase().indexOf('stop') != -1)
          ? 'danger'
          : 'primary'
          " @click="callFunc(item)">
          {{ item.name }}
        </el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <!-- <el-button type="primary" v-if="PL_IF" @click="batchPass" :disabled="this.sels.length===0">批量审批</el-button> -->
    <el-table :data="users" highlight-current-row @current-change="selectCurrentRow" v-loading="listLoading"
      @selection-change="selsChange" style="width: 100%">
      <el-table-column prop="Subject" label="课程名称" width sortable></el-table-column>
      <el-table-column prop="SortOrder" label="排序" width="80" sortable></el-table-column>
      <el-table-column prop="Teacher" label="授课老师" width sortable></el-table-column>
      <el-table-column prop="Type" label="课程类型" width sortable :formatter="formatType"></el-table-column>
      <el-table-column prop="Thumbnail" label="缩略图" width sortable>
        <template scope="scope">
          <el-image style="width: 160px; height: 90px"
            v-if="scope.row.Thumbnail == 'https://share.51i.cc/' ? false : true" :src="scope.row.Thumbnail"></el-image>
          <span v-if="scope.row.Thumbnail == 'https://share.51i.cc/' ? true : false">暂无图片</span>
        </template>
      </el-table-column>

      <el-table-column prop="CreateTime" label="创建日期" :formatter="formatDateTime" width sortable></el-table-column>
      <el-table-column prop="Status" label="状态" :formatter="formatStatus" width sortable></el-table-column>

      <el-table-column prop="IdentityIdsStr" label="分配角色" width sortable></el-table-column>
      <el-table-column label="点赞/点踩" width="120">
        <template scope="scope">
          <div>
            <span style="color: #d51900;">{{ scope.row.InitialLikes }}</span> / <span style="color: #666;">{{ scope.row.InitialDislikes }}</span>
          </div>
          <div>
            <el-link type="primary" @click="handleVoteDetail(scope.row.Id, scope.row.Subject)">
              查看明细
            </el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template scope="scope">
          <el-link type="primary" @click="handleOpen(scope.row.Id)">
            详情
          </el-link>
          |
          <el-link type="primary" @click="handleEdit(scope.row.Id)">
            编辑
          </el-link>
          <span v-if="scope.row.Type == 1 ? true : false"> | </span>
          <el-link v-if="scope.row.Type == 1 ? true : false" type="primary" @click="handleDetailOpen(scope.row.Id)">
            查看签到码
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="50" :total="total"
        style="float: right"></el-pagination>
    </el-col>

    <el-dialog :title="dialog_title" :visible.sync="editFormVisible" v-model="editFormVisible"
      :before-close="editForm_close" :close-on-click-modal="false">
      <!-- <div style="padding: 20px">
        <el-button type="primary" @click="link_class()">关联课程</el-button>
        <el-button type="primary" @click="link_class_jl()">关联教练</el-button>
      </div> -->
      <el-form :model="editForm" label-width="180px" :rules="editFormRules" ref="editForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="课程名称" prop="Subject">
              <el-input :disabled="DETAIS_IF" v-model="editForm.Subject" auto-complete="off"
                placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="课程类型" prop="Type">
              <el-select v-model="editForm.Type" :disabled="DETAIS_IF" placeholder="请选择" style="width: 100%"
                @change="Type_change">
                <el-option label="线上培训" :value="0"></el-option>
                <el-option label="线下培训" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="状态" prop="Status">
              <el-select v-model="editForm.Status" :disabled="DETAIS_IF" placeholder="请选择" style="width: 100%">
                <el-option label="正常" :value="1"></el-option>
                <el-option label="禁用" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="密码" prop="PassWord">
              <el-input :disabled="DETAIS_IF" v-model="editForm.PassWord" auto-complete="off"
                placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="排序" prop="SortOrder">
              <el-input-number :disabled="DETAIS_IF" v-model="editForm.SortOrder" :min="0" :max="9999"
                style="width: 100%" placeholder="数值越小越靠前"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="授课老师" prop="Teacher">
              <el-input :disabled="DETAIS_IF" v-model="editForm.Teacher" auto-complete="off"
                placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="评论区" prop="IsOpenEvaluation">
              <el-select v-model="editForm.IsOpenEvaluation" :disabled="DETAIS_IF" placeholder="请选择"
                style="width: 100%">
                <el-option label="开启" :value="true"></el-option>
                <el-option label="关闭" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="初始点赞数" prop="InitialLikes">
              <el-input-number :disabled="DETAIS_IF" v-model="editForm.InitialLikes" :min="0" :max="999999"
                style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="初始点踩数" prop="InitialDislikes">
              <el-input-number :disabled="DETAIS_IF" v-model="editForm.InitialDislikes" :min="0" :max="999999"
                style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="上级分组" prop="ParentId">
              <el-select :disabled="DETAIS_IF" v-model="editForm.ParentId" filterable placeholder="请选择"
                :filter-method="ParentId_change" @change="ParentId_change_upt_CurriculumGroupId" style="width: 100%">
                <el-option v-for="item in ParentCurriculumGroup_list" :key="item.Value" :label="item.Value"
                  :value="item.Key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="课程分组" prop="CurriculumGroupId">
              <el-select :disabled="DETAIS_IF" v-model="editForm.CurriculumGroupId" filterable placeholder="请选择"
                :filter-method="CurriculumGroupId_change" style="width: 100%">
                <el-option v-for="item in CurriculumGroupId_list" :key="item.Value" :label="item.Value"
                  :value="item.Key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="课程描述" prop="Reamrk">
              <el-input :disabled="DETAIS_IF" v-model="editForm.Reamrk" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" v-if="!isOnLine">
            <el-form-item label="标签" prop="Tids">
              <el-select multiple :disabled="DETAIS_IF" v-model="editForm.Tids" placeholder="请选择标签" style="width: 100%">
                <el-option :key="0" :label="'没有选择标签'" :value="0"></el-option>
                <el-option v-for="item in tags" :key="item.Key" :label="item.Value" :value="item.Key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="isOnLine">
          <el-col :span="24">
            <el-form-item label="分配培训角色" prop="Reamrk">
              <el-select :disabled="DETAIS_IF" v-model="editForm.IdentityIds" filterable multiple
                placeholder="请选择可观看的学员角色，默认不选则全部可见" style="width: 100%">
                <el-option v-for="item in memberIdentityErtificates" :key="item.Id" :label="item.Name"
                  :value="item.Id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" v-if="isOnLine">
            <el-form-item label="缩略图">
              <el-upload :disabled="DETAIS_IF" class="avatar-uploader" action="/api/Img/ImgUp" :show-file-list="false"
                :on-success="handleAvatarSuccess" :headers="token">
                <img v-if="thumbnail_imageUrl" :src="thumbnail_imageUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <div style="color: red; font-size: 12px">
                *建议上传图片宽高比例（16 ：9）
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="isOnLine">
          <el-col :span="24">
            <el-form-item label="视频 / PDF">
              <!-- <el-upload action="" :disabled="DETAIS_IF" class="avatar-uploader" :file-list="videolist"
                accept=".mp4,.txt" :limit="1" :http-request="handleVideoPut" :on-exceed="handleVideoExceed" :show-file-list="false"
                > <el-button type="primary">点击上传</el-button>
              </el-upload> -->
              <el-upload action="" :disabled="DETAIS_IF" class="avatar-uploader" :file-list="videolist"
                accept=".mp4,.txt,.pdf" :http-request="handleVideoPut" :show-file-list="false">
                <el-button type="primary">点击上传</el-button>
              </el-upload>
              <div style="color: red; font-size: 12px">
                *建议素材文件格式：MP4 PDF
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="isOnLine">
          <el-col :span="24">
            <el-form-item label="素材文件" prop="Link">
              <a :href="previewFile(editForm.Link)" target="_blank">{{
                editForm.Link
              }}</a>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editForm_close">取消</el-button>
        <el-button v-if="!DETAIS_IF" type="primary" @click.native="editSubmit('editForm')" :loading="editLoading">
          确认
        </el-button>
      </div>
    </el-dialog>

    <el-dialog :title="dialog_title" :visible.sync="detailFormVisible" v-model="detailFormVisible"
      :before-close="detailForm_close" :close-on-click-modal="false" width="500px">
      <el-form :model="detailForm" label-width="180px" ref="detailForm">
        <el-row style="text-align: center">
          <el-col :span="24">
            <el-image style="width: 200px; height: 200px" :src="QrCode_imageUrl">
            </el-image>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="detailForm_close">取消</el-button>
      </div>
    </el-dialog>

    <!-- 投票明细弹框 -->
    <el-dialog :title="'投票明细 - ' + voteDialogTitle" :visible.sync="voteFormVisible"
      :before-close="voteForm_close" :close-on-click-modal="false" width="800px">
      <!-- 预设数据 -->
      <div style="margin-bottom: 16px; padding: 12px; background: #f5f7fa; border-radius: 4px;">
        <div style="font-weight: bold; margin-bottom: 8px; color: #606266;">预设数据</div>
        <span style="margin-right: 20px;">预设点赞：<strong style="color: #d51900;">{{ voteInitialLikes }}</strong></span>
        <span>预设点踩：<strong style="color: #666;">{{ voteInitialDislikes }}</strong></span>
      </div>
      <!-- 真实用户数据 -->
      <div style="margin-bottom: 16px;">
        <div style="font-weight: bold; margin-bottom: 8px; color: #606266;">真实用户数据</div>
        <span style="margin-right: 20px;">点赞总数：<strong style="color: #d51900;">{{ voteRealLikes }}</strong></span>
        <span style="margin-right: 20px;">点踩总数：<strong style="color: #666;">{{ voteRealDislikes }}</strong></span>
        <el-select v-model="voteFilter" placeholder="筛选" style="width: 120px; margin-right: 10px;" @change="loadVoteList">
          <el-option label="全部" :value="0"></el-option>
          <el-option label="点赞" :value="1"></el-option>
          <el-option label="点踩" :value="-1"></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="exportVoteList">导出 Excel</el-button>
      </div>
      <el-table :data="voteList" v-loading="voteLoading" style="width: 100%">
        <el-table-column prop="MemberName" label="用户姓名" width="120"></el-table-column>
        <el-table-column prop="MemberPhone" label="手机号" width="140"></el-table-column>
        <el-table-column prop="VoteTypeDesc" label="操作类型" width="100">
          <template scope="scope">
            <el-tag :type="scope.row.VoteType === 1 ? 'danger' : 'info'" size="small">
              {{ scope.row.VoteTypeDesc }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="UpdateTime" label="操作时间" :formatter="formatDateTime"></el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handleVotePageChange" :page-size="votePageSize"
        :total="voteTotal" style="margin-top: 16px; text-align: right;"></el-pagination>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="voteForm_close">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 视频修复入口按钮（固定在页面右下角，仅超级管理员可见） -->
    <div class="fix-fab" v-if="isSuperAdmin" @click="handleVideoFix" title="视频Content-Type修复">
      <i class="el-icon-s-tools"></i>
    </div>

    <!-- 密码验证弹框 -->
    <el-dialog title="操作验证" :visible.sync="fixPasswordVisible" width="360px" :close-on-click-modal="false" append-to-body>
      <el-form @submit.native.prevent="fixPasswordConfirm">
        <el-form-item label="请输入操作密码">
          <el-input v-model="fixPassword" type="password" placeholder="请输入密码" show-password auto-complete="new-password"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="fixPasswordVisible = false">取消</el-button>
        <el-button type="primary" @click="fixPasswordConfirm">确认</el-button>
      </div>
    </el-dialog>

    <!-- 视频修复面板 -->
    <el-dialog title="视频 Content-Type 修复工具" :visible.sync="fixPanelVisible" width="800px" :close-on-click-modal="false" :before-close="fixClose" append-to-body>
      <!-- 统计信息 -->
      <div class="fix-stats" v-if="fixScanList.length > 0">
        <el-tag>总视频: {{ fixScanList.length }}</el-tag>
        <el-tag type="warning">需修复: {{ fixTodoList.length }}</el-tag>
        <el-tag type="success">已修复: {{ fixDoneList.length }}</el-tag>
        <el-tag type="danger" v-if="fixFailedList.length > 0">失败: {{ fixFailedList.length }}</el-tag>
      </div>

      <!-- 进度条 -->
      <el-progress
        v-if="fixRunning || fixDoneList.length > 0"
        :percentage="fixTodoList.length > 0 ? Math.round((fixCurrentIndex / fixTodoList.length) * 100) : 0"
        :status="fixRunning ? undefined : (fixFailedList.length > 0 ? 'warning' : 'success')"
        :stroke-width="18"
        style="margin: 12px 0;"
      ></el-progress>

      <!-- 操作按钮组 -->
      <div class="fix-actions">
        <el-button type="primary" size="small" icon="el-icon-search" @click="fixStartScan" :loading="fixScanning" :disabled="fixRunning || fixRollingBack">
          {{ fixScanning ? '扫描中...' : '扫描视频' }}
        </el-button>
        <el-button type="success" size="small" icon="el-icon-video-play" @click="fixStartExecute" :disabled="fixTodoList.length === 0 || fixRunning || fixScanning || fixRollingBack">
          开始修复
        </el-button>
        <el-button type="warning" size="small" icon="el-icon-video-pause" @click="fixPause" v-if="fixRunning && !fixPaused">
          暂停
        </el-button>
        <el-button type="success" size="small" icon="el-icon-video-play" @click="fixResume" v-if="fixRunning && fixPaused">
          继续
        </el-button>
        <el-button type="danger" size="small" icon="el-icon-refresh-left" @click="fixRollbackAll" :loading="fixRollingBack" :disabled="fixDoneList.length === 0 || fixRunning || fixScanning">
          {{ fixRollingBack ? '回滚中...' : `回滚全部 (${fixDoneList.length})` }}
        </el-button>
      </div>

      <!-- 执行日志 -->
      <div class="fix-log-box" ref="fixLogBox">
        <div v-if="fixLogs.length === 0" class="fix-log-empty">点击「扫描视频」开始</div>
        <div v-for="(log, idx) in fixLogs" :key="idx" class="fix-log-item" :class="'fix-log-' + log.type">
          <span class="fix-log-time">{{ log.time }}</span>
          <span class="fix-log-msg">{{ log.msg }}</span>
        </div>
      </div>

      <div slot="footer">
        <el-button @click="fixClose" :disabled="fixRunning || fixRollingBack">关闭</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from '../../../util/date'
import {
  CurriculumList,
  CurriculumPost,
  CurriculumPut,
  CurriculumGet,
  QrCodeCurriculumGet,
  GetCurriculumGroupSelectList,
  GetCurriculumGroupSecondarySelectList,
  IdentityId_GetList,
  getExamTagListPage,
  CurriculumVoteGetList,
  CurriculumVoteGetStats,
  CurriculumVoteExport,
  ScanVideoContentType,
  FixSingleVideoContentType,
  RollbackVideoContentType,
} from '../../api/api'
import { getButtonList } from '../../promissionRouter'
import Toolbar from '../../components/Toolbar'
const path = require('path')
const OSS = require('ali-oss')

// const aliHeaders = {
//   // 指定Object的存储类型。
//   'x-oss-storage-class': 'Standard',
//   // 指定Object的访问权限。
//   'x-oss-object-acl': 'private',
//   // 通过文件URL访问文件时，指定以附件形式下载文件，下载后的文件名称定义为example.jpg。
//   // 'Content-Disposition': 'attachment; filename="example.jpg"'
//   // 设置Object的标签，可同时设置多个标签。
//   'x-oss-tagging': 'Tag1=1&Tag2=2',
//   // 指定PutObject操作时是否覆盖同名目标Object。此处设置为true，表示禁止覆盖同名Object。
//   'x-oss-forbid-overwrite': 'true',
// };
export default {
  components: { Toolbar },
  data() {
    return {
      tags: [],
      ParentCurriculumGroup_list: [],
      CurriculumGroupId_list: [],
      fileList: [],
      token: {},
      DETAIS_IF: true,
      READ: true,
      READ_IF: true,
      UPLoad_IF: true,
      UPLoad_IF_Show: false,
      isShowHide: false,
      parentId: 0,
      dialog_title: '',
      detailFormVisible: false,
      videolist: [],
      detailForm: {},
      QrCode_imageUrl: '',
      editLoading: false,
      memberIdentityErtificates: [],
      editForm: {
        // ClassDate: "",
        // ClassStartTimeKey: "",
      },
      editFormRules: {
        Subject: [{ required: true, message: '请输入', trigger: 'blur' }],
        Type: [{ required: true, message: '请输入', trigger: 'blur' }],
        Status: [{ required: true, message: '请选择', trigger: 'change' }],
      },
      editFormVisible: false,
      editFormVisible_class: false,
      editFormVisible_jl: false,
      buttonList: [],
      managercode_list: [],
      currentRow: null,
      PL_IF: true,
      filters: {
        Subject: '',
        Teacher: '',
        Type: -1,
      },
      users: [],
      users_dialog: [],
      users_dialog_jl: [],
      total: 0,
      total_dialog: 0,
      page: 1,
      page_dialog: 1,
      page_dialog_jl: 1,
      thumbnail_imageUrl: '',
      isOnLine: false,
      listLoading: false,
      sels: [], //列表选中列
      TencentMeetingNumber_if: false,
      // 投票明细相关
      voteFormVisible: false,
      voteDialogTitle: '',
      voteCurriculumId: 0,
      voteList: [],
      voteTotal: 0,
      votePage: 1,
      votePageSize: 10,
      voteFilter: 0,
      voteLoading: false,
      voteInitialLikes: 0,
      voteInitialDislikes: 0,
      voteRealLikes: 0,
      voteRealDislikes: 0,
      // 视频修复相关
      fixPasswordVisible: false,
      fixPassword: '',
      fixPanelVisible: false,
      fixScanning: false,
      fixRunning: false,
      fixPaused: false,
      fixScanList: [],
      fixTodoList: [],
      fixDoneList: [],
      fixFailedList: [],
      fixCurrentIndex: 0,
      fixLogs: [],
      isSuperAdmin: false,
      fixRollingBack: false,
    }
  },
  methods: {
    // 投票明细相关方法
    async handleVoteDetail(curriculumId, subject) {
      this.voteCurriculumId = curriculumId
      this.voteDialogTitle = subject || ''
      this.voteFilter = 0
      this.votePage = 1
      this.voteFormVisible = true
      // 从列表数据中获取预设值
      const curriculum = this.users.find(item => item.Id === curriculumId)
      if (curriculum) {
        this.voteInitialLikes = curriculum.InitialLikes || 0
        this.voteInitialDislikes = curriculum.InitialDislikes || 0
      }
      await this.loadVoteStats()
      await this.loadVoteList()
    },
    async loadVoteStats() {
      const res = await CurriculumVoteGetStats({ curriculumId: this.voteCurriculumId })
      if (res.data && res.data.success) {
        // 真实用户数据 = 总数 - 预设数
        this.voteRealLikes = (res.data.response.Likes || 0) - this.voteInitialLikes
        this.voteRealDislikes = (res.data.response.Dislikes || 0) - this.voteInitialDislikes
      }
    },
    async loadVoteList() {
      this.voteLoading = true
      const params = {
        CurriculumId: this.voteCurriculumId,
        VoteType: this.voteFilter === 0 ? null : this.voteFilter,
        PageIndex: this.votePage,
        PageSize: this.votePageSize,
      }
      const res = await CurriculumVoteGetList(params)
      this.voteLoading = false
      if (res.data && res.data.success) {
        this.voteList = res.data.response.data || []
        this.voteTotal = res.data.response.dataCount || 0
      }
    },
    handleVotePageChange(page) {
      this.votePage = page
      this.loadVoteList()
    },
    async exportVoteList() {
      const params = {
        CurriculumId: this.voteCurriculumId,
        VoteType: this.voteFilter === 0 ? null : this.voteFilter,
      }
      const res = await CurriculumVoteExport(params)
      if (res.data && res.data.success) {
        const downloadUrl = 'https://share.51i.cc' + res.data.msg
        window.open(downloadUrl, '_blank')
      } else {
        this.$message({ message: '导出失败', type: 'error' })
      }
    },
    voteForm_close() {
      this.voteFormVisible = false
    },
    // ====== 视频修复相关方法 ======
    handleVideoFix() {
      this.fixPassword = ''
      this.fixPasswordVisible = true
    },
    fixPasswordConfirm() {
      if (this.fixPassword !== '123456') {
        this.$message({ message: '密码错误', type: 'error' })
        return
      }
      this.fixPasswordVisible = false
      this.fixPanelVisible = true
      this.fixScanList = []
      this.fixTodoList = []
      this.fixDoneList = []
      this.fixFailedList = []
      this.fixLogs = []
      this.fixRunning = false
      this.fixPaused = false
      this.fixCurrentIndex = 0
      this.fixRollingBack = false
    },
    fixAddLog(msg, type) {
      const time = new Date().toLocaleTimeString()
      this.fixLogs.push({ time, msg, type: type || 'info' })
      this.$nextTick(() => {
        const el = this.$refs.fixLogBox
        if (el) el.scrollTop = el.scrollHeight
      })
    },
    async fixStartScan() {
      this.fixScanning = true
      this.fixScanList = []
      this.fixTodoList = []
      this.fixDoneList = []
      this.fixFailedList = []
      this.fixLogs = []
      this.fixAddLog('开始扫描所有MP4视频...')
      try {
        const res = await ScanVideoContentType()
        if (res.data && res.data.success) {
          this.fixScanList = res.data.response || []
          this.fixTodoList = this.fixScanList.filter(x => x.NeedFixContentType)
          this.fixAddLog(`扫描完成：共 ${this.fixScanList.length} 个视频，${this.fixTodoList.length} 个需要修复`, 'success')
          if (this.fixTodoList.length === 0) {
            this.fixAddLog('所有视频Content-Type均正常，无需修复', 'success')
          }
        } else {
          this.fixAddLog(`扫描失败：${res.data && res.data.msg}`, 'error')
        }
      } catch (e) {
        this.fixAddLog(`扫描异常：${e.message}`, 'error')
      }
      this.fixScanning = false
    },
    async fixStartExecute() {
      if (this.fixTodoList.length === 0) {
        this.$message({ message: '没有需要修复的视频', type: 'warning' })
        return
      }
      this.fixRunning = true
      this.fixPaused = false
      this.fixCurrentIndex = 0
      this.fixDoneList = []
      this.fixFailedList = []
      this.fixAddLog(`开始修复，共 ${this.fixTodoList.length} 个视频...`)
      await this.fixProcessNext()
    },
    async fixProcessNext() {
      while (this.fixCurrentIndex < this.fixTodoList.length) {
        if (this.fixPaused) {
          this.fixAddLog('已暂停，等待继续...', 'warn')
          return
        }
        const item = this.fixTodoList[this.fixCurrentIndex]
        this.fixAddLog(`[${this.fixCurrentIndex + 1}/${this.fixTodoList.length}] 修复: ${item.Subject} (ID:${item.Id})`)
        try {
          const res = await FixSingleVideoContentType({ id: item.Id })
          if (res.data && res.data.success) {
            const r = res.data.response
            this.fixDoneList.push({
              ...item,
              oldContentType: r.OldContentType,
              newContentType: r.NewContentType,
            })
            this.fixAddLog(`  ✓ ${r.Message} (${r.OldContentType} → ${r.NewContentType})`, 'success')
          } else {
            this.fixFailedList.push({ ...item, reason: res.data && res.data.msg })
            this.fixAddLog(`  ✗ 失败: ${res.data && res.data.msg}`, 'error')
          }
        } catch (e) {
          this.fixFailedList.push({ ...item, reason: e.message })
          this.fixAddLog(`  ✗ 异常: ${e.message}`, 'error')
        }
        this.fixCurrentIndex++
      }
      this.fixRunning = false
      this.fixAddLog(`修复完成：成功 ${this.fixDoneList.length} 个，失败 ${this.fixFailedList.length} 个`, this.fixFailedList.length > 0 ? 'warn' : 'success')
    },
    fixPause() {
      this.fixPaused = true
    },
    fixResume() {
      this.fixPaused = false
      this.fixAddLog('继续执行...')
      this.fixProcessNext()
    },
    async fixRollbackAll() {
      if (this.fixDoneList.length === 0) {
        this.$message({ message: '没有可回滚的记录', type: 'warning' })
        return
      }
      try {
        await this.$confirm(`确定要回滚全部 ${this.fixDoneList.length} 条已修复的记录吗？这将恢复原来的Content-Type。`, '回滚确认', { type: 'warning' })
      } catch { return }

      this.fixRollingBack = true
      this.fixAddLog(`开始回滚 ${this.fixDoneList.length} 条记录...`, 'warn')
      const rollbackList = [...this.fixDoneList]
      let successCount = 0
      for (let i = 0; i < rollbackList.length; i++) {
        const item = rollbackList[i]
        this.fixAddLog(`[${i + 1}/${rollbackList.length}] 回滚: ${item.Subject} (ID:${item.Id})`)
        try {
          const res = await RollbackVideoContentType({ id: item.Id, oldContentType: item.oldContentType })
          if (res.data && res.data.success) {
            this.fixAddLog(`  ↩ ${res.data.msg}`, 'success')
            successCount++
          } else {
            this.fixAddLog(`  ✗ 回滚失败: ${res.data && res.data.msg}`, 'error')
          }
        } catch (e) {
          this.fixAddLog(`  ✗ 回滚异常: ${e.message}`, 'error')
        }
      }
      if (successCount === rollbackList.length) {
        this.fixDoneList = []
      }
      this.fixRollingBack = false
      this.fixAddLog(`回滚完成：${successCount}/${rollbackList.length} 条成功`, successCount === rollbackList.length ? 'success' : 'warn')
    },
    fixClose() {
      if (this.fixRunning) {
        this.$message({ message: '请先暂停或等待执行完成', type: 'warning' })
        return
      }
      this.fixPanelVisible = false
    },
    previewFile(uri) {
      return (
        `https://preview.51i.cc/onlinePrevieww?watermarkTxt=Acuvue iLearn&url=` +
        uri
      )
    },
    handleAvatarSuccess(res, file) {
      if (file.response.success) {
        this.thumbnail_imageUrl = URL.createObjectURL(file.raw)
        this.editForm.Thumbnail = file.response.response
      } else {
        this.$message({
          message: file.response.msg,
          type: 'error',
        })
      }
    },
    handleLinkAvatarSuccess(res, file) {
      if (file.response.success) {
        this.editForm.Link = 'https://share.51i.cc/' + file.response.response
      } else {
        this.$message({
          message: file.response.msg,
          type: 'error',
        })
      }
    },
    Type_change(e, num) {
      //选择课程类型，隐藏显示图片和视频上传
      if (e == 1) {
        this.isOnLine = false
      } else {
        this.isOnLine = true
      }
    },
    link_class() {
      this.CurriculumList()
      this.page_dialog = 1
      this.editFormVisible_class = true
    },
    selsChange: function (value) {
      this.sels = value
    },
    async TagsGet() {
      getExamTagListPage().then((res) => {
        this.tags = res.data.response
        console.log(this.editForm)
      })
    },
    async editSubmit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (!this.editForm.Thumbnail) {
            if (this.editForm.Type == 0) {
              this.$message({
                message: '请上传缩略图',
                type: 'error',
              })
              return
            }
          }
          if (this.editForm.ParentId > 0) {
            if (!this.editForm.CurriculumGroupId) {
              this.$message({
                message: '请选择课程分组',
                type: 'error',
              })
              return
            }
          }
          if (this.editForm.IdentityIds) {
            this.editForm.IdentityIds = this.editForm.IdentityIds.join(', ')
          }
          let data
          if (this.dialog_title == '新增') {
            data = await CurriculumPost(this.editForm)
          } else {
            data = await CurriculumPut(this.editForm)
          }
          if (data.data.success) {
            this.editFormVisible = false
            this.$message({
              message: data.data.msg,
              type: 'success',
            })
            this.getModules_search()
            this.editForm = {}
          } else {
            this.editFormVisible = false
            this.$message({
              message: data.data.msg,
              type: 'error',
            })
            this.getModules_search()
            this.editForm = {}
          }
        } else {
          return false
        }
      })
    },
    handleAdd() {
      this.ParentId_GetList_fn()
      this.CurriculumGroupId_GetList_fn(0, '')
      this.TagsGet()
      this.editFormVisible = true
      this.dialog_title = '新增'
      this.DETAIS_IF = false
      this.thumbnail_imageUrl = ''
      this.link_Url = ''
    },
    editForm_close() {
      this.editFormVisible = false
      this.editForm = {}
    },
    async details_CurriculumGet(ids) {
      const { data } = await CurriculumGet({
        id: ids,
      })
      if (data.response.IdentityIds) {
        data.response.IdentityIds = data.response.IdentityIds.split(', ')
          .map(function (item) {
            return parseInt(item.trim(), 10)
          })
          .sort(function (a, b) {
            return b - a
          })
        console.log(data.response.IdentityIds)
      }
      this.editForm = data.response
      this.parentId = data.response.ParentId
      if (data.response.ParentId == 0) {
        this.$set(this.editForm, 'ParentId', null)
        this.$set(this.editForm, 'CurriculumGroupId', null)
      }
      this.editFormVisible = true
      if (this.editForm.Type == 1) {
        this.isOnLine = false
      } else {
        this.isOnLine = true
      }
      if (data.response.Thumbnail) {
        this.thumbnail_imageUrl =
          'https://share.51i.cc/' + data.response.Thumbnail
      }
    },
    detailForm_close() {
      this.detailFormVisible = false
      this.detailForm = {}
    },
    async QrCodeDetails_CurriculumGet(ids) {
      const { data } = await QrCodeCurriculumGet({
        id: ids,
      })
      this.detailForm = data.response
      if (data.response.QRCodeUrl) {
        this.QrCode_imageUrl = data.response.QRCodeUrl
        // console.log(data.response.QRCodeUrl)
      }
      this.detailFormVisible = true
    },
    // 查看二维码
    async handleDetailOpen(ids) {
      this.QrCodeDetails_CurriculumGet(ids)
      this.DETAIS_IF = true
      this.dialog_title = '签到码'
    },
    // 查看
    async handleOpen(ids) {
      await this.details_CurriculumGet(ids)
      await this.ParentId_GetList_fn()
      await this.CurriculumGroupId_GetList_fn(this.parentId, '')
      await this.TagsGet()
      this.DETAIS_IF = true
      this.READ = true
      this.READ_IF = true
      // this.editFormVisible = true;
      this.dialog_title = '查看'
    },
    async handleEdit(ids) {
      await this.details_CurriculumGet(ids)
      await this.ParentId_GetList_fn()
      await this.CurriculumGroupId_GetList_fn(this.parentId, '')
      await this.TagsGet()
      // this.editFormVisible = true;
      this.dialog_title = '编辑'
      this.DETAIS_IF = false
    },
    selectCurrentRow(val) {
      this.currentRow = val
      //此处根据选中的券，判断是否符合导入
      let row = this.currentRow
    },
    callFunc(item) {
      this[item.Func].apply(this, item)
    },
    ParentId_change(e) {
      this.ParentId_GetList_fn(e)
    },
    async ParentId_GetList_fn(e) {
      const { data } = await GetCurriculumGroupSelectList({
        name: e,
      })
      this.ParentCurriculumGroup_list = data.response
    },
    ParentId_change_upt_CurriculumGroupId(e) {
      this.ParentCurriculumGroup_list.find((item) => {
        //model就是上面的数据源
        if (item.Key === e) {
          this.$set(this.editForm, 'CurriculumGroupId', null)
          this.CurriculumGroupId_GetList_fn(item.Key, '')
        }
      })
    },
    CurriculumGroupId_change(e) {
      this.CurriculumGroupId_GetList_fn(this.parentId, e)
    },
    async CurriculumGroupId_GetList_fn(parentId, e) {
      const { data } = await GetCurriculumGroupSecondarySelectList({
        parentId: parentId,
        name: e,
      })
      this.CurriculumGroupId_list = data.response
    },

    //日期显示转换
    formatDateTime: function (row, column) {
      let data = row[column.property]
      if (data == null) {
        return null
      } else {
        return util.formatDate.format(new Date(data), 'yyyy-MM-dd')
      }
    },
    formatStatus: function (row, column) {
      let data = row[column.property]
      if (data == 1) {
        return '正常'
      } else if (data == 0) {
        return '禁用'
      } else {
        return null
      }
    },
    formatType: function (row, column) {
      let data = row[column.property]
      if (data == 1) {
        return '线下培训'
      } else if (data == 0) {
        return '线上培训'
      } else {
        return null
      }
    },
    formatThumbnail: function (row, column) {
      let data = row[column.property]
      return '暂无图片'
    },
    handleCurrentChange(val) {
      this.page = val
      this.getModules()
    },
    getModules_search() {
      this.page = 1
      this.getModules()
    },
    ImportUserTagDetail() {
      this.page = 1
      this.getModules()
    },
    // handleChange(file)
    // {
    //   //验证文件格式
    //   const isXlS =
    //     file.type ===
    //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
    //     file.type === "application/vnd.ms-excel";
    //   if (!isXlS) {
    //     this.$message.error("Please upload files in xls and xlsx formats!");
    //     return;
    //   }
    // },
    handlebefore() {
      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
    },
    handonerror() {
      // console.log("超时失败");
      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      this.$message({
        message: '您的上传已超时，请再次尝试',
        type: 'error',
      })
      loading.close()
    },
    handleSuccess(file, fileLis) {
      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      if (file.success == true) {
        loading.close()
        this.QUEST_IF = true
        this.$alert(file.msg, '提示', {
          confirmButtonText: '确定',
        })
      } else if (file.success == false) {
        loading.close()
        this.$alert(file.msg, '提示', {
          confirmButtonText: '确定',
        })
      } else {
        loading.close()
        this.$message({
          message: '您的上传已超时，请再次尝试',
          type: 'error',
        })
      }
    },
    //获取用户列表
    getModules() {
      let para = this.filters
      para.page = this.page
      this.listLoading = true
      CurriculumList(para).then((res) => {
        this.total = res.data.response.dataCount
        this.users = res.data.response.data
        this.listLoading = false
        // this.buttonList.forEach(element => {
        //   if(element.Func == 'setCouponSystemPush')
        //   {
        //      this.isShowHide = true;
        //   }
        // });
      })
    },
    //删除
    handleDel(ids) {
      // console.log(ids);
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning',
      })
        .then(() => {
          this.listLoading = true
          //NProgress.start();
          // let para = { id: ids };
          ClassScheduleDelete({
            id: ids,
          }).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false
              return
            }
            this.listLoading = false
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: '删除成功',
                type: 'success',
              })
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
              })
            }

            this.getModules_search()
          })
        })
        .catch(() => { })
    },
    //审核,阻止，驳回保存
    saveMemberSaveAudit(id, status) {
      var msg = ''
      if (status == -1) {
        msg = '确认驳回吗?'
      } else if (status == 1) {
        msg = '确认通过审核吗?'
      } else if (status == 2) {
        msg = '确认阻止吗?'
      }
      this.$confirm(msg, '提示', {
        type: 'warning',
      })
        .then(() => {
          this.listLoading = true
          MemberSaveAudit({
            id: id,
            status: status,
          }).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false
              return
            }
            this.listLoading = false
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: 'success',
              })
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
              })
            }

            this.getModules_search()
          })
        })
        .catch(() => { })
    },
    //建立一个可存取到该file的url
    getObjectURL(file) {
      var url = null
      // 下面函数执行的效果是一样的，只是需要针对不同的浏览器执行不同的 js 函数而已
      if (window.createObjectURL != undefined) {
        // basic
        url = window.createObjectURL(file)
      } else if (window.URL != undefined) {
        // mozilla(firefox)
        url = window.URL.createObjectURL(file)
      } else if (window.webkitURL != undefined) {
        // webkit or chrome
        url = window.webkitURL.createObjectURL(file)
      }
      return url
    },
    // 下面的函数为图片上传所用函数
    handleVideoExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length
        } 个文件`
      )
    },
    async handleVideoPut(param) {
      try {
        const loading = this.$loading({
          lock: true,
          text: 'loading......',
        })
        var file = param.file;
        let filename = this.getfilename();
        var index = file.name.lastIndexOf('.');
        var ext = file.name.substr(index);
        filename = filename + ext;

        // 使用 multipartUpload 上传文件
        await this.client.multipartUpload('202303_PlusStudy/Upload/' + filename, file)
          .then((ress) => {
            this.$set(this.editForm, 'Link', 'https://share.51i.cc/' + ress.name)
            this.$message.success('文件上传成功！')
            loading.close()
          })
          .catch((err) => {
            param.onError(err)
            console.error('上传失败:', err)
            this.$message.error('文件上传失败！')
            loading.close()
          });
      } catch (e) {
        console.error(e)
        param.onError(e)
        this.$message.error('文件上传失败！')
        loading.close()
      }
    },
    getfilename() {
      let date = new Date()
      let fmt = 'yyyyMMddHHmmssS'
      var o = {
        'M+': date.getMonth() + 1, //月份
        'd+': date.getDate(), //日
        'H+': date.getHours(), //小时
        'm+': date.getMinutes(), //分
        's+': date.getSeconds(), //秒
        'q+': Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds(), //毫秒
      }
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + '').substr(4 - RegExp.$1.length)
        )
      for (var k in o)
        if (new RegExp('(' + k + ')').test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ('00' + o[k]).substr(('' + o[k]).length)
          )
      return fmt
    },
  },
  mounted() {
    const client = new OSS({
      // yourregion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
      region: 'oss-cn-shanghai',
      // 阿里云账号AccessKey拥有所有API的访问权限，风险很高。强烈建议您创建并使用RAM用户进行API访问或日常运维，请登录RAM控制台创建RAM用户。
      accessKeyId: 'LTAI5t7FwVELwhxrxav6LkbZ',
      accessKeySecret: '74Y3NDZmJqiIHQAm03dXfMRSnUG2fd',
      // 填写Bucket名称。
      bucket: 'share-ui',
    })
    this.client = client

    // let roleNames = JSON.parse(localStorage.getItem("roleNames"));
    this.getModules()
    let tokenStr = window.localStorage.Token
    this.token = {
      Authorization: 'Bearer ' + tokenStr,
    }
    console.log(this.token)
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : []
    this.buttonList = getButtonList(this.$route.path, routers)

    // 判断是否超级管理员
    try {
      var user = JSON.parse(window.localStorage.user)
      this.isSuperAdmin = user && user.uLoginName === 'blogadmin'
    } catch (e) {
      this.isSuperAdmin = false
    }
    IdentityId_GetList().then((res) => {
      this.memberIdentityErtificates = res.data.response
    })
  },
}
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.avatar {
  width: 320px !important;
  height: 180px !important;
  display: block;
}

/* 视频修复浮动按钮 */
.fix-fab {
  position: fixed;
  right: 24px;
  bottom: 24px;
  width: 48px;
  height: 48px;
  background: #909399;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  cursor: pointer;
  box-shadow: 0 2px 12px rgba(0,0,0,0.2);
  z-index: 999;
  transition: background 0.2s;
}
.fix-fab:hover {
  background: #606266;
}

/* 统计标签 */
.fix-stats {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

/* 操作按钮组 */
.fix-actions {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

/* 日志面板 */
.fix-log-box {
  background: #1e1e1e;
  color: #d4d4d4;
  border-radius: 6px;
  padding: 12px;
  height: 320px;
  overflow-y: auto;
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.8;
}
.fix-log-empty {
  color: #666;
  text-align: center;
  padding-top: 140px;
}
.fix-log-item {
  white-space: pre-wrap;
  word-break: break-all;
}
.fix-log-time {
  color: #666;
  margin-right: 8px;
}
.fix-log-info .fix-log-msg { color: #d4d4d4; }
.fix-log-success .fix-log-msg { color: #67c23a; }
.fix-log-warn .fix-log-msg { color: #e6a23c; }
.fix-log-error .fix-log-msg { color: #f56c6c; }
</style>
<style>
.el-button--primary {
  background-color: #409eff !important;
  border-color: #409eff !important;
}

/* 
  .el-link.el-link--primary:hover {
    color: #409eff !important;
  } */

.el-link.el-link {
  color: #409eff !important;
}

.el-link.is-underline:hover:after {
  border-bottom: 1px solid #409eff !important;
}

.el-link.el-link--default:after,
.el-link.el-link--primary.is-underline:hover:after,
.el-link.el-link--primary:after {
  border-color: #409eff !important;
}

.el-pager li.active {
  color: #409eff !important;
}
</style>
